import styled, { css } from 'styled-components';

import { mediaMixin } from '@zillow/constellation';

export const StyledHeadingLink = styled.span`
  ${mediaMixin(
    'sm',
    css`
      float: right;
    `,
  )}
`;
